<template>
	<div>
		<h2>身障手冊審核</h2>
		<div>
			<h3>
				<span
					class="glyphicon glyphicon-check"
					aria-hidden="true"
					style="margin-top:20px;"
				></span>
				Step1: 身障手冊
			</h3>
			<hr style="margin-top:5px;" />
						<modify-disability-card
				:pk="pk"
				page="manager"
			/>
			<!--<template v-if="item.review_status != 2">-->
			<template>
				<!--step 2-->
				<h3>
					<span
						class="glyphicon glyphicon-check"
						aria-hidden="true"
						style="margin-top:20px;"
					></span>
					Step2: 審核結果
				</h3>
				<hr style="margin-top:5px;" />
				<div class="form-group">
					<input type="radio" id="success" value="success" v-model="result" />
					<label for="success">成功</label>
					<br />
					<input type="radio" id="error" value="error" v-model="result" />
					<label for="error">退回</label>
					<br />
					<template v-if="result == 'error'">
						<label for="reason">原因</label>
						<input type="text" id="reason" v-model="reason" />
					</template>
				</div>
				<button class="btn btn-primary" @click="$router.go(-1)">上一頁</button>
				<button class="btn btn-primary" @click="review()">送出</button>
			</template>
		</div>
	</div>
</template>

<script>
import ModifyDisabilityCard from "@/components/components/manageDisabilitycard.vue";
import { disabilityCardRest } from "@/api/genericUser";

export default {
	components: {
		ModifyDisabilityCard
	},
	data() {
		return {
			pk: this.$route.params.id,
			reason: "",
			result: "success", //success or error
			item: {
				review_status: 1,
			}
		};
	},
	metaInfo: {
		title: "身障手冊審核"
	},
	async mounted() {
		try {
			const res = await disabilityCardRest.read(this.pk);
			this.item = res.data;
		} catch (err) {
			// generic error handler
			this.$errorHandler({ error: err });
		}
	},
	methods: {
		async review() {
			const data = {
				review_message: this.reason
			};
			if(this.result === "success"){
				data["review_status"] = 2;
			} else {
				data["review_status"] = 0;
			}
			try {
				const res = await disabilityCardRest.partialupdate(this.pk, data);
				await this.$root.$message.open({
					status: 200,
					message: "審核已完成"
				});
				this.$router.go(-1);
			} catch (err) {
				// generic error handler
				this.$errorHandler({ error: err });
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.y-scroll-box {
	height: 230px;
	overflow: auto;
}
.btn {
	&.btn-primary {
		margin-right: 1rem;
	}
}
</style>
